import styled from "styled-components";
import {
  Header as BaseHeader, Answer as BaseAnswer, CloseButton as BaseCloseButton,
} from "../weeklyFormSummaryModal/styles";

export {
  Overlay, Modal, Title, Question, QuestionLabel, MoodIcon,
} from "../weeklyFormSummaryModal/styles";

export const Header = styled(BaseHeader)`
  align-items: flex-start;
`;

export const CloseButton = styled(BaseCloseButton)`
  font-size: 1.7rem;
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Period = styled.span`
  font-size: 0.72rem;
  color: #6b7680;
`;

export const Answer = styled(BaseAnswer)`
  color: #1b2b3a;
`;

export const MoodAnswer = styled(Answer)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Stats = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
`;

export const Stat = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 20px 22px;
  border-radius: 8px;
  background: #f4f4f4;
  color: #2F6D92;
`;

export const StatText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const StatValue = styled.span`
  font-size: 1.05rem;
  font-weight: 700;
  color: #1b2b3a;
`;

export const StatTotal = styled.span`
  font-weight: 400;
  color: #a5adb4;
`;

export const StatLabel = styled.span`
  font-size: 0.75rem;
  color: #6b7680;
`;
